<template>
  <Teleport to="body">
    <Transition name="global-image-preview-fade">
      <div
        v-if="isOpen && hasContent"
        class="fixed inset-0 z-2000 bg-black/80 backdrop-blur-[2px] flex items-center justify-center select-none cursor-zoom-out"
        @click="emitClose"
      >
        <div
          class="relative"
          :class="
            previewType === 'compare'
              ? 'w-[90vw] h-[90vh]'
              : 'max-w-[90%] max-h-[90%]'
          "
          @click.stop
        >
          <!-- 图片 -->
          <ImageComparator
            v-if="previewType === 'compare'"
            :left-image="compare.leftImage"
            :right-image="compare.rightImage"
            :initial-position="compare.initialPosition ?? 50"
            :enable-preview="false"
            class="w-full h-full"
          />

          <img
            v-else-if="previewType === 'image'"
            :src="src"
            class="max-h-[90vh] max-w-full rounded-xl shadow-2xl"
            draggable="false"
          />

          <!-- 音频 -->
          <div
            v-else-if="previewType === 'audio'"
            class="w-[min(520px,90vw)] rounded-xl bg-black/70 shadow-2xl"
          >
            <VinylRecordPlayer
              :audio-src="src"
              :player-size="180"
              :show-native-controls="true"
            />
          </div>

          <!-- 视频 -->
          <video
            v-else
            :src="src"
            controls
            autoplay
            loop
            playsinline
            muted
            class="max-h-[90vh] max-w-full rounded-xl shadow-2xl"
          ></video>

          <UIcon
            name="material-symbols-light:cancel-outline-rounded"
            @click="emitClose"
            class="absolute -top-4 -right-4 text-white text-2xl cursor-pointer"
          />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed, watch } from "vue";
import ImageComparator from "@/components/ai-tools/ImageComparator.vue";
import VinylRecordPlayer from "@/components/ai-tools/VinylRecordPlayer.vue";

const props = defineProps({
  isOpen: { type: Boolean, default: false },
  src: { type: String, default: "" },
  compare: { type: Object, default: null },
});

const hasCompare = computed(() => {
  return Boolean(
    props.compare?.leftImage?.trim() && props.compare?.rightImage?.trim()
  );
});

const hasContent = computed(() => {
  return Boolean(props.src?.trim() || hasCompare.value);
});

/** 根据 URL 判断是否为视频（忽略 query/hash，支持常见扩展名） */
function isVideoSrcUrl(url) {
  if (!url || typeof url !== "string") return false;
  const path = url.split(/[?#]/)[0].toLowerCase();
  return /\.(mp4|webm|m4v|mov)$/i.test(path);
}

/** 根据 URL 判断是否为音频（忽略 query/hash，支持常见扩展名） */
function isAudioSrcUrl(url) {
  if (!url || typeof url !== "string") return false;
  const path = url.split(/[?#]/)[0].toLowerCase();
  return /\.(mp3|wav|m4a|aac|flac|oga|ogg|opus|pcm)$/i.test(path);
}

const previewType = computed(() => {
  if (hasCompare.value) return "compare";
  if (isAudioSrcUrl(props.src)) return "audio";
  return isVideoSrcUrl(props.src) ? "video" : "image";
}); // image | video | audio | compare

// 监听 src 自动判断类型
watch(
  () => props.src,
  () => {},
  { immediate: true }
);

// // 监听 isOpen
// watch(
//   () => props.isOpen,
//   (val) => {
//     console.log("isOpen:", val, "src:", props.src, "compare:", props.compare);
//   },
//   { immediate: true }
// );

const emit = defineEmits(["close"]);
const emitClose = () => emit("close");
</script>

<style scoped>
.global-image-preview-fade-enter-active,
.global-image-preview-fade-leave-active {
  transition: opacity 0.2s ease;
}
.global-image-preview-fade-enter-from,
.global-image-preview-fade-leave-to {
  opacity: 0;
}
</style>
